export enum TemplateTypes {
	original = 'original',
	quick = 'quick',
}
